export const shuffleList = <T extends unknown>(list: Array<T>) => {
  const listIndices = Array.from({ length: list.length }, (_, i) => i);
  const listIndicesShuffled = listIndices.sort(() => Math.random() - 0.5);
  const shuffledList = listIndicesShuffled.map((index) => list[index]);
  return shuffledList;
};
